/**
 * VistaService — vista preferida al entrar a la app: "clasica" (dashboard) o "chat".
 * Se guarda en localStorage al usar los botones "Vista chat" / "Vista clásica".
 */
const KEY = "kb_vista";
export const VISTAS = { clasica: "clasica", chat: "chat" };

export const VistaService = {
  get() {
    try { return localStorage.getItem(KEY) === VISTAS.chat ? VISTAS.chat : VISTAS.clasica; } catch { return VISTAS.clasica; }
  },

  set(vista) {
    try { localStorage.setItem(KEY, vista === VISTAS.chat ? VISTAS.chat : VISTAS.clasica); } catch {}
  },

  /** Ruta de inicio según la preferencia. */
  inicio() {
    return this.get() === VISTAS.chat ? "chat" : "dashboard";
  },
};
